// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogError_dialogContent__21Wo9"};